import { Component, OnInit } from '@angular/core';
import { MenuItem } from '../core/interfaces/menu-items';
import { ActivatedRoute } from '@angular/router';
import { Pages } from '../core/constants/shared.constants';

@Component({
  selector: 'app-voice',
  templateUrl: './voice.component.html',
  styleUrls: ['./voice.component.scss']
})
export class VoiceComponent implements OnInit {

  public module: string = "";
  public title: string = "";
  public menuItems: MenuItem[];

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.module = this.route.snapshot.data.module;
    this.title = this.route.snapshot.data.menuTitle;
    this.getMenuItems();
  }

  private getMenuItems() {
    this.menuItems = [
      {
        title: 'Overview',
        url: `/voice-out/${Pages.Overview}`
      },
      {
        title: 'Channel behavior',
        url: `/voice-out/channel-behavior`,
        children: [
          {
            title: 'Play',
            url: `/voice-out/channel-behavior/play`
          },
          {
            title: 'Say',
            url: `/voice-out/channel-behavior/say`
          },
          {
            title: 'Dial',
            url: `/voice-out/channel-behavior/dial`
          },
          {
            title: 'TrunkDial',
            url: `/voice-out/channel-behavior/trunk-dial`
          },
          {
            title: 'Menu',
            url: `/voice-out/channel-behavior/menu`
          },
          {
            title: 'Collect',
            url: `/voice-out/channel-behavior/collect`
          },
          {
            title: 'CollectSpeech',
            url: `/voice-out/channel-behavior/collect-speech`
          },
          {
            title: 'AskAssistant',
            url: `/voice-out/channel-behavior/ask-assistant`
          },
          {
            title: 'AskGenerativeAI',
            url: `/voice-out/channel-behavior/ask-ai`
          },
          {
            title: 'Redirect',
            url: `/voice-out/channel-behavior/redirect`
          },
          {
            title: 'SetVariable',
            url: `/voice-out/channel-behavior/set-variable`
          },
          {
            title: 'Condition',
            url: `/voice-out/channel-behavior/condition`
          },
          {
            title: 'Silence',
            url: `/voice-out/channel-behavior/silence`
          },
          {
            title: 'Record',
            url: `/voice-out/channel-behavior/record`
          },
          {
            title: 'Conference',
            url: `/voice-out/channel-behavior/conference`
          },
          {
            title: 'AgentConference',
            url: `/voice-out/channel-behavior/agent-conference`
          },
          {
            title: 'AgentPhone',
            url: `/voice-out/channel-behavior/agent-phone`
          },
          {
            title: 'RemoteAgent',
            url: `/voice-out/channel-behavior/remote-agent`
          },
          {
            title: 'AgentGroup',
            url: `/voice-out/channel-behavior/agent-group`
          },
          {
            title: 'Storage',
            url: `/voice-out/channel-behavior/storage`
          },
          {
            title: 'HttpRequest',
            url: `/voice-out/channel-behavior/httprequest`
          },
          {
            title: 'GoTo',
            url: `/voice-out/channel-behavior/go-to`
          },
          {
            title: 'AppendNodes',
            url: `/voice-out/channel-behavior/append-nodes`
          },
          {
            title: 'Sms',
            url: `/voice-out/channel-behavior/sms-request`
          },
          {
            title: 'Email',
            url: `/voice-out/channel-behavior/email-request`
          },
          {
            title: 'Whatsapp',
            url: `/voice-out/channel-behavior/whatsapp-request`
          }
        ]
      },
      {
        title: "Make  outbound call",
        url: `/voice-out/${Pages.SendRequest}`
      },
      {
        title: "Get call details",
        url: `/voice-out/${Pages.GetStatus}`
      },
      {
        title: "Get data storage for a voice call",
        url: `/voice-out/${Pages.StorageDetails}`
      },
      {
        title: "Hang up call",
        url: `/voice-out/hangup`
      },
      {
        title: "Archive request",
        url: `/voice-out/archive`
      },
      {
        title: "Cancel request",
        url: `/voice-out/cancel`
      },
      {
        title: "Interfere call",
        url: `/voice-out/interfere`
      },
      {
        title: "External action",
        url: `/voice-out/external-action`
      },
      {
        title: "Voice status",
        url: `/voice-out/${Pages.Status}`
      },
      {
        title: "Hangup causes",
        url: `/voice-out/${Pages.HangupCause}`
      },
      {
        title: "Text-to-speech voices",
        url: `/voice-out/tts-voice-id`
      },
      {
        title: "Transcription  languages",
        url: `/voice-out/languages-code`
      },
      {
        title: "Recording Storage Period",
        url: `/voice-out/recording-storage`
      },
      {
        title: "Rephrase with ChatGPT",
        url: `/voice-out/${Pages.RephraseInstructions}`
      },
      {
        title: 'How to',
        url: `/voice-out/how-to/say-text`,
        children: [
          {
            title: 'Say a text on a voice call',
            url: `/voice-out/how-to/say-text`
          },
          {
            title: 'Rephrase with ChatGPT',
            url: `/voice-out/how-to/chat-gpt`
          },
          {
            title: 'Play an audio file from url',
            url: `/voice-out/how-to/play-url`
          },
          {
            title: 'Build a basic IVR',
            url: `/voice-out/how-to/build-ivr`
          },
          {
            title: 'Build an IVR with automatic speech recognition',
            url: `/voice-out/how-to/asr-music`
          },
          {
            title: 'Get notified when an option is selected within a Menu action',
            url: `/voice-out/how-to/menu-status-callback`
          },
          {
            title: 'Collect digits',
            url: `/voice-out/how-to/collect-digit`
          },
          {
            title: 'Record an outbound voice call',
            url: `/voice-out/how-to/record-call`
          },
          {
            title: 'Record a conversation from a dial action',
            url: `/voice-out/how-to/record-dial`
          },
          {
            title: 'Record and transcribe an outbound voice call',
            url: `/voice-out/how-to/record-transcribe`
          },
          {
            title: 'Send email when a recording is ready',
            url: `/voice-out/how-to/record-send-email`,
          },
          {
            title: 'Get notified when a Dial action is answered, hang up or not answered',
            url: `/voice-out/how-to/dial-event-callback`,
          },
          {
            title: 'Get notified when a collect action is completed',
            url: `/voice-out/how-to/collect-callback`,
          },
          {
            title: 'Interfere on dial action',
            url: `/voice-out/how-to/interfere-dial`
          },
          {
            title: 'Hang up an outbound voice call',
            url: `/voice-out/how-to/hang-up`
          },
          {
            title: 'Get notified when a transcription is ready',
             url: `/voice-out/how-to/transcription-callback`
          },
          {
            title: 'Use your own web application to control the call flow',
            url: `/voice-out/how-to/redirect`
          },
          {
            title: 'Create a survey',
            url: `/voice-out/how-to/survey`
          },
          //{
          //  title: 'Create a conference',
          //  url: `/voice-out/how-to/conference`
          //},
          {
            title: 'Get notified when an event occurs during a conference',
            url: `/voice-out/how-to/conference-callback`
          },
          {
            title: 'Record a conference',
            url: `/voice-out/how-to/conference-recording`
          },
          {
            title: "Get notified when an agent starts/ends a conversation",
            url:"/voice-out/how-to/agent-conference"
          },
          {
            title: "Get notified when an agent phone starts/ends a call",
            url: "/voice-out/how-to/agent-phone"
          },
        ]
      },
    ];
  }

}
